import { gql } from '@apollo/client'
import { apiClient } from 'shared/helpers/api'
import { mutate, query } from 'shared/helpers/graphql'

export async function getLivingLinks() {
  return query(gql`
    query Long_short_links {
      long_short_links {
        id
        configuration
        is_living
        link
        link_short
        provider
      }
    }
  `)
}

export async function getPropertyLivingLinks(propertyName) {
  return query({
    variables: {
      propertyName: propertyName,
    },
    query: gql`
      query Long_short_links($propertyName: String) {
        long_short_links_by_property_name(property_name: $propertyName) {
          id
          configuration
          link
          description
          link_short
          provider
        }
      }
    `,
  })
}

export async function upsertLink(payload) {
  return mutate(
    {
      longShortLinks: [payload],
    },
    gql`
      mutation Upsert_long_short_links($longShortLinks: [long_short_links_input]) {
        upsert_long_short_links(long_short_links: $longShortLinks) {
          id
          link_short
        }
      }
    `,
  )
}

export function createSignmapIntegrationLink(payload) {
  return apiClient.post('/api/integrations/engrain/link', payload)
}
